import React from 'react';
import { IProps, IState } from './types';
import { Redirect } from 'react-router-dom';
import loginService from 'bff/services/loginService';
import sweetAlertService from 'utils/sweetAlertService';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { RouterSettings } from 'constants/models/routerSettings';

class Unlock extends React.Component<IProps, IState> {
    state:IState = {
      isRedirect: false
    }

    componentDidMount = async () => {
      if (this.props.match.params.uuid) {
        const res = await loginService.statusUnlock(this.props.match.params.uuid);

        let val;
        const title = '會員解鎖結果';
        if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
          val = await sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            title: title,
            html: `${res.MWHEADER.RETURNDESC}<br />(error code : ${res.MWHEADER.RETURNCODE})`
          }).then(() => true);
        } else {
          val = await sweetAlertService.modal({
            title: title,
            html: res.MWHEADER.RETURNDESC
          }).then(() => true);
        }

        this.setState({ isRedirect: val });
      }
    }

    render () {
      return this.state.isRedirect ? <Redirect to={RouterSettings.Home} /> : null;
    }
};

export default Unlock;
